import { render, staticRenderFns } from "./OnboardingAndProductTours.vue?vue&type=template&id=3390f46a&scoped=true&"
import script from "./OnboardingAndProductTours.vue?vue&type=script&lang=js&"
export * from "./OnboardingAndProductTours.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAndProductTours.vue?vue&type=style&index=0&id=3390f46a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3390f46a",
  null
  
)

export default component.exports